import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss']
})
export class SuccessComponent implements OnInit {

  allData: any = {}
  organizer: any = {}
  dashboardLoginUrl = environment.dashboardLoginUrl;

  constructor(private router: Router) { }

  // ngOnInit(): void {

  //   const organizers = JSON.parse(localStorage.getItem('organizer') || 'null');
  //   const user = JSON.parse(localStorage.getItem('user') || 'null');

  //   this.organizer = JSON.parse(user);

  //   console.log(organizers.first_name + ' ' + organizers.last_name)
  //   console.log(organizers.organizer_type)
  //   console.log(organizers.email)
    

  //   console.log(this.organizer.organizer.first_name + ' ' + this.organizer.organizer.last_name)
  //   console.log(this.organizer.organizer.organizer_type)
  //   console.log(this.organizer.organizer.email)

  // }

  ngOnInit(): void {
  const organizerLS = JSON.parse(localStorage.getItem('organizer') || 'null');
  const userLS = JSON.parse(localStorage.getItem('user') || 'null');

  // 🔥 Ek hi variable me final organizer set
  this.organizer = userLS?.organizer || organizerLS || null;

  if (!this.organizer) {
    console.error('Organizer data not found in localStorage');
    return;
  }

  console.log(this.organizer.first_name + ' ' + this.organizer.last_name);
  console.log(this.organizer.organizer_type);
  console.log(this.organizer.email);
}

  logout() {
    localStorage.clear();
    this.router.navigate(['/login'], { replaceUrl: true });
  }
}
